import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import "intersection-observer";

const Head = ({
    title = "",
    desc = "",
    src = "",
    alt = "",
    url = "",
    keywords = "",
    type = "page"
}) => (
    <Helmet>
        <title>{title}</title>
        <meta charSet="utf-8" />
        <meta name="description" content={desc} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content="TriMotion" />

        <meta name="og:title" content={title} />
        <meta property="og:type" content={type} />
        <meta property="og:description" content={desc} />
        <meta property="og:site_name" content="TriMotion" />
        <meta property="og:locale" content="nl_NL" />
        <meta
            property="article:author"
            content="https://www.facebook.com/TriMotionVisuals"
        />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={src} />
        <meta property="og:image:alt" content={alt} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:creator" content="@TriMotion" />
        <meta name="twitter:image:src" content={src} />
        <meta name="twitter:image:alt" content={alt} />
        <meta name="twitter:domain" content="www.trimotion.nl" />

        <link
            rel="preload"
            as="style"
            href="https://fonts.googleapis.com/css?family=Poppins:400,800&display=swap"
            rel="stylesheet"
            async
        />
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta
            name="msapplication-config"
            content="../browserconfig.xml"
        />
        <meta name="theme-color" content="#000061" />

        
    </Helmet>
);

Head.propTypes = {
    title: PropTypes.string,
    desc: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string,
    keywords: PropTypes.string
};

export default Head;